export default "__VITE_ASSET__df74e433__"